<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 单号:{{ form.no }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else> 创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}</span>
            </el-col>
            <el-col :span="2" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" v-if="getIsView()" label="创建人">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 创建人:{{ form.createdUserName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 所属科室:{{ form.ownerDeptName }}</span>
            </el-col>
            <el-col :span="2" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="applyUserId" label="申请人" v-if="getIsView()">
                <SelectTable :disabled="!editMode" :columns="userColumns" :innerName="form.applyUserName"
                  :dataList="STATIC_Users" @filterMethod="getUsers" @change="userChange" />
              </el-form-item>
              <span class="viewText" v-else> 申请人:{{ form.applyUserName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="applyDeptName" label="申请科室" v-if="getIsView()">
                <!-- <el-input disabled v-model="form.applyDeptName"></el-input> -->
                <el-select v-if="system_setting.IsUseWard" v-model="form.applyDeptName" :disabled="!editMode" placeholder="请选择"
                  @change="applyDeptChange" style="width:100%">
                  <el-option v-for="item in deptList" :key="item.idGroup" :label="item.deptName +' '+ (item.wardName?item.wardName:'')" :value="item.idGroup"></el-option>
                </el-select>
                <el-select v-else v-model="form.applyDeptName" :disabled="!editMode" placeholder="请选择"
                @change="applyDeptChange" style="width:100%">
                <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              </el-form-item>
              <span class="viewText" v-else> 申请科室:{{ form.applyDeptName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="启用状态" prop="state" v-if="getIsView()">
                <el-switch :disabled="!editMode" v-model="form.state" active-color="#286AB4" inactive-color="#D4D4D4"
                  :active-value="1" :inactive-value="0" />
              </el-form-item>
              <span class="viewText" v-else> 启用状态:{{ form.state==1?'启用':'停用' }}</span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="warehouseName" label="目标仓库">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="getOneLevelWarehouses" @change="warehouseChange" style="width:100%">
                  <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 目标仓库:{{ form.warehouseName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="type" label="自动申领标识" v-if="getIsView()">
                <el-select v-model="form.type" :disabled="!editMode" placeholder="请选择" style="width:100%" @change="typeChange">
                  <el-option v-for="item in AutoPurchaseApplyOptions" :key="item.id" :label="item.name"
                    :value="item.id">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 自动申领标识:{{  AutoPurchaseApplyOptions.find(item => item.id === form.type)?.name }}</span>
            </el-col>
            <el-col v-if="form.type==1" :span="2" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="inTransitDay" label="在途天数" v-if="getIsView()">
                  <el-input-number :disabled="!editMode" :min="0" :controls="false" v-model="form.inTransitDay"
                    placeholder="请输入在途天数"  style="width:100%"></el-input-number>
              </el-form-item>
              <span class="viewText" v-else> 在途天数:{{ form.inTransitDay }}</span>
            </el-col>

            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="type" label="普通单据类型" v-if="getIsView()">
                <el-select v-model="form.docType" :disabled="!editMode" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in AutoApplyOptions" :key="item.id" :label="item.name"
                    :value="item.id">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 普通单据类型:{{  AutoApplyOptions.find(item => item.id === form.docType)?.name }}</span>
            </el-col>
            <el-col :span="2" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="interval" label="设置周期" v-if="getIsView()">
                <el-input-number :disabled="!editMode" :min="1" :controls="false" v-model="form.interval"
                  placeholder="请输入设置周期" @change="intervalChange" style="width:100%"></el-input-number>
              </el-form-item>
              <span class="viewText" v-else> 设置周期:{{ form.interval }}</span>
            </el-col>
            <el-col :span="2" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="intervalUnit" label="周期单位" v-if="getIsView()">
                <el-select v-model="form.intervalUnit" :disabled="!editMode" placeholder="请选择" @change="intervalChange"
                  style="width:100%">
                  <el-option v-for="item in DateTimeUnitOptions" :key="item.id" :label="item.name"
                    :value="item.id">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 周期单位:{{ form.intervalUnit }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="nextRunDate" label="下次执行时间" v-if="getIsView()">
                <el-date-picker :disabled="!editMode" v-model="form.nextRunDate" :picker-options="pickerOptions"  type="date" placeholder="下次执行时间"
                @change="nextRunDateChange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%" >
              </el-date-picker> 
                <!-- <el-input disabled placeholder="" v-model="form.nextRunDate"></el-input> -->
              </el-form-item>
              <span class="viewText" v-else> 下次执行时间:{{ form.nextRunDate }}</span>
            </el-col>
          </el-row>
          <el-row>
          
          
            <!-- </el-row>
          <el-row> -->
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="备注" prop="remark">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 备注:{{ form.remark }}</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">申领明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick
              @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
            @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column type="index"  width="50" fixed> </el-table-column>
            <el-table-column prop="productName" label="产品" min-width="180" fixed>
              <template slot-scope="scope">
                <SelectTable :disabled="!editMode" :columns="autoApplySupplierProductColumns" :placeholder="'请选择产品'"
                  :innerName="scope.row.productName" :dataList="STATIC_ApplySupplierProducts"
                  @filterMethod="getProductList" @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specName" label="规格型号" fixed
            min-width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="supplierProductNo" label="供应商产品编码"
              min-width="180"></el-table-column>
          
            <el-table-column label="最小包装数量" min-width="120">
              <template slot-scope="scope">
                <el-input-number  size="small" v-model="scope.row.packNumber"  @change="(res)=>numberEvt(res,scope.row)" :disabled="!editMode" :min="1"  label="请输入内容"></el-input-number>
              </template>
            </el-table-column>
  
            <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家"
              width="180"></el-table-column>
            <el-table-column prop="stateName" label="是否启用" width="120"></el-table-column>
            <el-table-column prop="remark" label="备注" :disabled="!editMode" min-width="200">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import InStockScan from '@/mixin/inStockScan-mixin'
import {
  SaveAutoPurchaseApplySetting,
  RejectAutoPurchaseApplySetting,
  GetAutoPurchaseApplySettingById,
  GetUserById
} from "@/api";
import { AutoPurchaseApplyOptions, DateTimeUnitOptions,AutoApplyOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, InStockScan],
  components: {
    SelectTable,
    ApproveInfo
  },
  data () {
    return {
      GetDataAction: GetAutoPurchaseApplySettingById,
      SaveDataAction: SaveAutoPurchaseApplySetting,
      reject: RejectAutoPurchaseApplySetting,
      form: {},

      DateTimeUnitOptions: DateTimeUnitOptions.filter(item => item.id >= 3),
      AutoPurchaseApplyOptions: AutoPurchaseApplyOptions,
      AutoApplyOptions:AutoApplyOptions,
      rules: {
        warehouseName: [
          { required: true, message: '请选择目标仓库', trigger: 'blur' }
        ],
        applyUserId: [
          { required: true, message: '请选择申请人', trigger: 'blur' }
        ],
        interval: [
          { required: true, message: '请输入设置周期', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择自动申领标识', trigger: 'blur' }
        ],
        inTransitDay: [
          { required: true, message: '请输入在途天数', trigger: 'blur' }
        ],
        nextRunDate:[
          { required: true, message: '请选择下次执行时间', trigger: 'blur' }
        ],
      },
      pickerOptions:{
        disabledDate(date) {
          // 禁用小于或等于当前日期的日期
          return date.getTime() <= Date.now();
        }
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      deptList: []

    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getOneLevelWarehouses('')
    // this.getProductList('')
    this.getUsers('')
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    typeChange(val){
      if(val != 1){
        this.form.inTransitDay = undefined
      }
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;

        this.form.nextRunDate = this.parseTime(new Date(this.form.nextRunDate), '{y}-{m}-{d}')

        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

      });
    },
    numberEvt(res, row) {
        // 校验 res 是否为有效数值，非数值则设为0
        if (typeof res !== 'number' || isNaN(res)) {
            res = 0;
        }
        // 转换为整数（示例使用向下取整，可根据需求调整为 ceil/round）
        const intRes = Math.floor(res);
        // 更新 row 中的对应值（假设绑定的字段为 quantity，根据实际字段名调整）
        this.$set(row, 'packNumber', intRes); // 使用 $set 确保 Vue 响应式更新
    },
    // 保存
    submit () {
      
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let arr = this.form.details.filter(res=>res.productId=='')
        if(arr.length>0){
          this.$my_message(`请选择产品后提交！`, "warning");
          return
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        applyUserId: this.userInfo.id,
        applyUserName: this.userInfo.name,
        applyDeptId: '',//this.userInfo.deptId,
        applyDeptName: '',//this.userInfo.deptName,
        warehouseId: '',
        warehouseName: '',
        type: 0,
        intervalUnit: 3,
        nextRunDate: '',
        remark: "",
        state: 1,
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        interval:undefined,
        inTransitDay:undefined,
        orgCode :sessionStorage.getItem('orgId')
      };
      let depts = []
      if(this.system_setting.IsUseWard){
        depts = this.userInfo.deptAndWardInfos
        this.form.applyDeptId = this.mySessionStorage.getDeptId()
        this.form.applyDeptName = this.mySessionStorage.getDeptName()+' '+this.mySessionStorage.getWardName()
        this.form.wardId = this.mySessionStorage.getWardId()

      }else{
        depts = this.userInfo.deptInfos
          this.form.applyDeptId = this.userInfo.deptId
        this.form.applyDeptName = this.userInfo.deptName
      }
      // if (depts && depts.length == 1) {
      

        this.getProductList('')
      // }

      this.deptList = depts
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.resetDetailFormData();
      this.getProductList('')
      this.form.details.push(this.childForm)
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        supplierProductNo: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        "minUnit": "",
        "manufacturerId": '',
        "remark": "",
        packNumber: 0
      };
    },
    // change event
    userChange (row) {
      this.form.applyDeptId = ''
      this.form.applyDeptName = ''
      this.deptList = []
      GetUserById({ id: row.id })
        .then(res => {
          this.form.applyUserId = res.returnData.id
          this.form.applyUserName = res.returnData.name
          let depts = []
          if(this.system_setting.IsUseWard){
            depts = res.returnData.deptAndWardInfos
            if (depts && depts.length == 1) {
              this.form.applyDeptId = depts[0].deptId
              this.form.applyDeptName = depts[0].deptName +' ' +(depts[0].wardName?depts[0].wardName:'')
              this.form.wardId =  depts[0].wardId
              this.getProductList('')
            }
          }else{

            depts = res.returnData.deptInfos
          if (depts && depts.length == 1) {
            this.form.applyDeptId = res.returnData.deptId
            this.form.applyDeptName = res.returnData.deptName

            this.getProductList('')
          }
        }

          this.deptList = depts
        })
    },
    applyDeptChange (val) {
      if(this.system_setting.IsUseWard){
        let ids = val.split('-')
        this.form.applyDeptId = ids[0]
        this.form.wardId = ids[1]
      }else{
        this.form.applyDeptId = val
      }
      this.getProductList('')
    },
    warehouseChange (val) {
      this.form.warehouseId = val
      let arr = this.STATIC_OneLevelWarehouses.filter(item => item.id == val)
      this.form.warehouseName = arr[0].name
    },
    productChange (row, val) {
      let id = row.id
      row = Object.assign(row, val)
      row.id = id
      row.supplierProductId = val.id
      row.supplierProductNo = val.no
      row.stateName = row.isEnabled == 1 ? "是" : "否"
      row.remark = ""
      row.packNumber = 1
    },
    intervalChange () {
      let num =  parseInt(this.form.interval)
      if( !isNaN(num) && num == 0){
        this.$my_message(`请输入正确的周期`, "warning");
        return
      }
   
      if (!this.form.interval || !this.form.intervalUnit) {
        this.form.nextRunDate = ''
        return;
      }

      let now = new Date();
      let date = new Date();
      // 天
      if (this.form.intervalUnit == 3) {
        date = new Date().setDate(now.getDate() + this.form.interval)
      }
      // 周
      else if (this.form.intervalUnit == 4) {
        date = new Date().setDate(now.getDate() + this.form.interval * 7)
      }
      // 月
      else if (this.form.intervalUnit == 5) {
        date = new Date().setMonth(now.getMonth() + this.form.interval)
      }
      // 年
      else if (this.form.intervalUnit == 6) {
        date = new Date().setMonth(now.getMonth() + this.form.interval * 12)
      }
      this.form.nextRunDate = this.parseTime(new Date(date), "{y}-{m}-{d}")
    },
    nextRunDateChange(val){
      console.log(val);
      
      this.form.nextRunDate = val
    },

    getProductList (keyWord) {
      if (!this.form.applyDeptId) {
        this.STATIC_ApplySupplierProducts = []
        return
      }
      let query = {
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 50,
        isEnabled: 1,
        deptId: this.form.applyDeptId,
        status: 2
      }
      // query.pageIndex = 1
      // query.pageSize = 50
      // query.isEnabled = 1
      // query.deptId = this.form.applyDeptId
      // query.status = 2

      this.getApplySupplierProducts(query)
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>

### 说明
1. **数值校验**：首先检查 `res` 是否为有效数值，非数值时设为0避免错误。
2. **整数转换**：使用 `Math.floor` 向下取整（可根据业务需求替换为 `Math.ceil` 或 `Math.round`）。
3. **响应式更新**：通过 `this.$set(row, 'quantity', intRes)` 更新数据，确保 Vue 能检测到变化并更新视图（`quantity` 为示例字段名，需根据实际绑定的字段名调整）。
